import notify from './Notify';

export default notify;
